// extracted by mini-css-extract-plugin
module.exports = {"titleIcon":"ViewChargeAffirm_titleIcon__1qCi6","inputPhoneContainer":"ViewChargeAffirm_inputPhoneContainer__1KI0J"};